module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_7-9d7d0c465a0f4f540e7509d3889db468.jpeg";